import {useState} from "react";
import { useLiveAPIContext } from "../contexts/LiveAPIContext";
function TextInput() {
const [text, setText] = useState("");
const {connected, client} = useLiveAPIContext();
const handleSend = async(e: React.FormEvent<HTMLFormElement>) => {
e.preventDefault();
client.send([{text: text.trim()}]);
setText("");
}
return (
<>
{connected && (
<form onSubmit={handleSend}>
<textarea id="textinput" value={text} rows={10} cols={50} onChange={(e) => setText(e.target.value)} placeholder="Type or paste a prompt..."></textarea>
<input disabled={text.length<1} type="submit" value="Send" />
</form>
)}
</>
);
}
export default TextInput;